module.exports = __webpack_public_path__ + "static/assets/d2cdd68af32d01249fe7d52f244305be.png";